import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.onResize = this.onResize.bind(this)
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
  }

  onResize() {
    if (window.innerWidth < 1200) {
      this.panelTarget.classList.add("hidden")
      this.panelTarget.dataset.currentId = ""
    }
  }

  toggle(event) {
    if (window.innerWidth < 1200) {
      event.preventDefault()
      window.location.href = event.currentTarget.href
      return
    }

    const panel = this.panelTarget
    const partnerId = event.currentTarget.dataset.partnerId

    if (panel.dataset.currentId === partnerId && !panel.classList.contains("hidden")) {
      panel.classList.add("hidden")
      panel.dataset.currentId = ""
    } else {
      panel.classList.remove("hidden")
      panel.dataset.currentId = partnerId
    }
  }
}
